import {Space} from "antd";
import type {
  CustomerLiveEventBooking,
  LegacyCustomerEvent,
} from "../../../../features/customer-live-events";
import {StyledNoUpcomingCallBox} from "../../../calls/upcoming-calls/upcoming-calls.style";
import {CustomerLiveClassCard} from "../card/customer/card";

export type TUpcomingClassesProps = {
  events?: (LegacyCustomerEvent | CustomerLiveEventBooking)[];
};

function UpcomingClassesCustomer({events}: TUpcomingClassesProps) {
  return (
    <Space direction="vertical" size={29} style={{display: "flex"}}>
      {events && events.length > 0 ? (
        events.map((liveClass) => (
          <CustomerLiveClassCard key={liveClass.id} eventData={liveClass} />
        ))
      ) : (
        <div style={{width: "100%"}}>
          <StyledNoUpcomingCallBox>
            <p className="info-text">
              You do not have any live event at the moment. Book a new live event to get
              started
            </p>
          </StyledNoUpcomingCallBox>
        </div>
      )}
    </Space>
  );
}

export {UpcomingClassesCustomer};
